// export const getArtistImageURL = (imageName) =>
//   `https://cms-api.manabakh.ir/v1/cms/api/artist-media/${encodeURIComponent(
//     imageName
//   )}`;

export const getArtistImageURL = (imageName) =>
  `https://fcdn.manabakh.ir/images/${encodeURIComponent(
    imageName
  )}`;
